import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  HealthcareProviderInformationClient,
  HealthcareProviderInformationRequest,
} from 'requests/nswag/nll/NLLClient';

async function updateCustomerHealthcareProviderInformation(request: HealthcareProviderInformationRequest) {
  const healthCareProviderClient = new HealthcareProviderInformationClient();
  return await healthCareProviderClient.upsertHealthcareProviderInformation(request);
}

export function useUpdateHealthcareProviderInformation(customerId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCustomerHealthcareProviderInformation,
    onSuccess: (_) => {
      queryClient.invalidateQueries({ queryKey: ['NllCustomer', customerId] });
    },
  });
}
